import { FormattedMessage } from "react-intl";
import { LabelLangString } from "component/LabelLang/label-lang.js";
import HtmlView from "component/htmlView/html-view";
import MainDepartment from "component/shared/main-department/MainDepartment";

function DataRequestContent({ currentLocale, servicesTools, getDepartment }) {
  return (
    <div className="row mt-5">
      <div className="col-12 col-lg-8">
        <div className="calnd-info">
          {servicesTools?.content !== null &&
          servicesTools?.content !== undefined ? (
            <HtmlView
              html={LabelLangString({
                id: "content",
                currentLocale,
                defaultValue: servicesTools.content,
                translations: servicesTools.serviceAndToolTranslation,
              })}
            />
          ) : (
            <FormattedMessage id="data-not-found" />
          )}
        </div>
      </div>
      <div className="col-12 col-lg-4">
        <MainDepartment getDepartment={getDepartment} />
      </div>
    </div>
  );
}

export default DataRequestContent;
